import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';

export const MeetAnfitrionDialog = ({ emailInicial, onCancel, onConfirm }) => {
  const [email, setEmail] = useState(emailInicial || '');
  return (
    <Dialog open onOpenChange={onCancel}>
      <DialogContent className="max-w-md" data-testid="meet-anfitrion-dialog">
        <DialogHeader><DialogTitle>Iniciar Google Meet como anfitrión</DialogTitle></DialogHeader>
        <p className="text-sm text-gray-600">
          Te damos permisos de coanfitrión en la reunión para la cuenta de Google que indiques (puede ser tu Gmail personal).
          Al abrir Meet, entrá con <b>esa misma cuenta</b>: si entrás sin cuenta o con otra, vas a ingresar como participante.
        </p>
        <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="tucuenta@gmail.com"
          data-testid="meet-anfitrion-email" />
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={onCancel}>Cancelar</Button>
          <Button size="sm" disabled={!email.includes('@')} onClick={() => onConfirm(email.trim())} data-testid="meet-anfitrion-confirmar">
            Abrir Meet
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
